/* العربية الفصحى. Written to read the same for every student: buttons are verbal nouns (إنشاء، إرسال، تأكيد),
   requests use "يُرجى" or the passive, and second-person present-tense verbs (which differ for a female reader) are
   avoided. University, product and test names stay in their official Latin form. */
import type { Dict } from './en';

export const ar: Dict = {
  'company.privacyEmail': 'hello@pathsabroad.com',
  'company.supportEmail': 'hello@pathsabroad.com',

  'app.skip': 'التخطي إلى المحتوى الرئيسي',
  'app.home': 'الصفحة الرئيسية لـ PathsAbroad',
  'lang.label': 'اللغة',
  'nav.sections': 'أقسام الحساب',
  'nav.overview': 'نظرة عامة',
  'nav.profile': 'الملف الشخصي',
  'nav.inbox': 'بريد الطلبات',
  'nav.plans': 'الباقات',
  'nav.extension': 'إضافة كروم',
  'nav.security': 'تسجيل الدخول والأمان',
  'nav.data': 'بياناتك',
  'nav.account': 'الحساب',
  'nav.planner': 'فتح المخطِّط',
  'nav.signin': 'تسجيل الدخول',
  'nav.signout': 'تسجيل الخروج',
  'footer.privacy': 'الخصوصية',
  'footer.terms': 'الشروط',
  'footer.note': 'لا إعلانات ولا تتبّع. نستخدم فقط ملفات تعريف الارتباط اللازمة لتسجيل دخولك.',

  'common.loading': 'جارٍ التحميل…',
  'common.retry': 'إعادة المحاولة',
  'common.continue': 'متابعة',
  'common.cancel': 'إلغاء',
  'common.save': 'حفظ التغييرات',
  'common.saving': 'جارٍ الحفظ…',
  'common.copied': 'تم النسخ',
  'common.copyFailed': 'تعذّر النسخ. يمكنك تحديد النص ونسخه يدويًا.',
  'common.show': 'إظهار',
  'common.hide': 'إخفاء',
  'common.showPassword': 'إظهار كلمة المرور',
  'common.hidePassword': 'إخفاء كلمة المرور',
  'common.optional': 'اختياري',
  'common.choose': 'اختيار…',
  'common.remove': 'حذف',
  'common.removeNamed': 'حذف {name}',
  'common.email': 'البريد الإلكتروني',
  'common.password': 'كلمة المرور',
  'common.on': 'مفعّل',
  'common.off': 'غير مفعّل',
  'common.opensNew': '(يُفتح في علامة تبويب جديدة)',
  'common.home': 'الانتقال إلى الصفحة الرئيسية',
  'session.checking': 'جارٍ التحقق من جلستك…',
  'session.error': 'تعذّر الوصول إلى PathsAbroad للتحقق من جلستك.',

  'err.bad_credentials': 'البريد الإلكتروني وكلمة المرور غير متطابقين. يمكنك المحاولة مرة أخرى أو إعادة تعيين كلمة المرور.',
  'err.email_not_confirmed': 'يلزم تأكيد بريدك الإلكتروني أولًا بإدخال الرمز المكوّن من 6 أرقام الذي أرسلناه إليك.',
  'err.bad_code': 'لم ينجح هذا الرمز. يُرجى التحقق منه والمحاولة مرة أخرى، أو طلب رمز جديد.',
  'err.already_paid': 'لديك هذه الباقة بالفعل لهذا الموسم.',
  'err.withdrawal_ack_required': 'يُرجى تحديد الخانة لتؤكد أنك تفهم أن كل المبيعات نهائية، ثم المحاولة مرة أخرى.',
  'err.version_conflict': 'تغيّر هذا المحتوى من مكان آخر. يُرجى إعادة تحميل الصفحة لرؤية أحدث نسخة.',
  'err.invalid': 'بعض البيانات تحتاج إلى مراجعة. يُرجى النظر في الحقل المحدَّد.',
  'err.not_found': 'لم نعثر على المطلوب، وربما حُذف.',
  'err.rate_limited': 'محاولات كثيرة. يُرجى الانتظار بضع دقائق ثم المحاولة مرة أخرى.',
  'err.forbidden': 'هذا غير متاح لحسابك.',
  'err.network': 'تعذّر الاتصال بـ PathsAbroad. يُرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.',
  'err.server_error': 'حدث خطأ من جهتنا. يُرجى المحاولة مرة أخرى بعد دقيقة.',
  'err.signed_out': 'انتهت جلستك. يُرجى تسجيل الدخول مرة أخرى.',
  'err.mfa_required': 'يُرجى إدخال رمز التحقق بخطوتين أولًا.',
  'err.guardian_consent_required': 'يلزم أن يوافق وليّ أمرك على حسابك أولًا.',
  'err.plan_required': 'تتطلب هذه الميزة باقة التقديم والوصول.',

  'v.email': 'يُرجى إدخال بريد إلكتروني صحيح مثل name@example.com.',
  'v.password': 'يُرجى استخدام 10 أحرف على الأقل.',
  'v.passwordMatch': 'كلمتا المرور غير متطابقتين.',
  'v.code': 'يُرجى إدخال الرمز المكوّن من 6 أرقام.',
  'v.required': 'يُرجى تعبئة هذا الحقل.',
  'v.tick': 'يُرجى تحديد هذه الخانة للمتابعة.',
  'v.choose': 'يُرجى اختيار أحد الخيارات.',

  'pw.hint': '10 أحرف على الأقل. الجملة القصيرة سهلة التذكّر وصعبة التخمين.',
  'pw.strength': 'القوة: {level}',
  'pw.too_short': 'قصيرة جدًا',
  'pw.weak': 'ضعيفة',
  'pw.fair': 'مقبولة',
  'pw.strong': 'قوية',

  'home.title': 'الدراسة في الخارج، خطوة واضحة تلو الأخرى.',
  'home.lead': 'يساعدك PathsAbroad على إيجاد الجامعات التي تناسبك، والتقديم إليها بنفسك، والاستعداد للتأشيرة بمعلومات من مصادر رسمية، ثم الاستقرار في بلد الدراسة.',
  'home.start': 'اعثر على جامعاتك',
  'home.signin': 'تسجيل الدخول',
  'home.planner': 'فتح المخطِّط',
  'home.pathTitle': 'مسارك',
  'home.step0.text': 'يكفي إدخال بياناتك مرة واحدة، وتبقى ملكًا لك: يمكنك تنزيلها أو حذفها في أي وقت.',
  'home.step1.text': 'يمكنك اختيار أي جامعة، حتى تلك التي لم نقترحها. ويبقى إرسال كل طلب ودفع كل الرسوم بيدك.',
  'home.step2.text': 'تصل رسائل القبول إلى صندوق بريد واحد مرتّبةً، مع إبراز الخطوات التالية المطلوبة منك.',
  'home.step3.text': 'قوائم متطلبات التأشيرة من مصادر رسمية، إلى جانب السكن وأسابيعك الأولى. معلومات عامة، وليست استشارة هجرة أو استشارة قانونية.',

  'phase.0': 'الملف',
  'phase.1': 'التقديم',
  'phase.2': 'القبول',
  'phase.3': 'الوصول',
  'phase.here': 'أنت هنا',
  'phase.done': 'مكتملة',
  'phase.summary': 'الخطوة {n} من 4: {name}',

  'auth.step': 'الخطوة {n} من {total}',
  'auth.saveList': 'احفظ قائمتك',
  'auth.beginWith': 'نبدأ بـ{school}',
  'auth.welcomeBack': 'مرحبًا بعودتك',
  'start.dob.title': 'ما تاريخ ميلادك؟',
  'start.dob.day': 'اليوم',
  'start.dob.month': 'الشهر',
  'start.dob.year': 'السنة',
  'dob.missing': 'يُرجى اختيار اليوم والشهر والسنة.',
  'dob.no_such_day': 'هذا التاريخ غير موجود. يُرجى التحقق من اليوم والشهر.',
  'dob.check': 'يُرجى التحقق من تاريخ ميلادك.',
  'start.blocked.title': 'عذرًا، لا يمكننا إنشاء حساب PathsAbroad لك.',
  'start.form.title': 'إنشاء حسابك',
  'start.form.emailHint': 'سنرسل إليه رمزًا للتأكد من أنه بريدك.',
  'start.form.lang': 'اللغة',
  'start.form.langHint': 'لغة التطبيق والرسائل التي نرسلها إليك.',
  'start.form.minor': 'يلزم أن يوافق وليّ أمرك على حسابك قبل حفظ بياناتك.',
  'start.form.agree': 'إنشاء الحساب يعني الموافقة على {terms} والإقرار بقراءة {privacy}.',
  'start.form.termsLink': 'شروط الاستخدام',
  'start.form.privacyLink': 'إشعار الخصوصية',
  'start.form.submit': 'إنشاء الحساب',
  'start.form.changeDob': 'تغيير تاريخ الميلاد',
  'start.haveAccount': 'لديك حساب بالفعل؟',

  'verify.title': 'رمز التحقق في بريدك الإلكتروني',
  'verify.sent': 'أرسلنا رمزًا مكوّنًا من 6 أرقام إلى {email}. قد يستغرق وصوله دقيقة.',
  'verify.noEmail': 'يُرجى إدخال البريد الإلكتروني الذي سجّلت به والرمز المكوّن من 6 أرقام الذي أرسلناه إليك.',
  'verify.code': 'الرمز المكوّن من 6 أرقام',
  'verify.submit': 'تأكيد البريد الإلكتروني',
  'verify.resend': 'إرسال رمز جديد',
  'verify.resendIn': 'إرسال رمز جديد بعد {time}',
  'verify.resent': 'أرسلنا رمزًا جديدًا إلى {email}.',
  'verify.rateLimited': 'طلبت عدة رموز. يُرجى الانتظار بضع دقائق قبل طلب رمز آخر.',
  'verify.noResend': 'للحصول على رمز جديد، يُرجى البدء من جديد، فنحن لا نحتفظ ببيانات التسجيل في هذا المتصفح.',
  'verify.startAgain': 'البدء من جديد',

  'callback.title': 'جارٍ تسجيل دخولك',
  'callback.working': 'لحظة من فضلك…',
  'callback.failed': 'لم ينجح رابط تسجيل الدخول هذا. ربما انتهت صلاحيته أو سبق استخدامه.',
  'callback.signin': 'الانتقال إلى تسجيل الدخول',

  'signin.title': 'تسجيل الدخول',
  'signin.forgot': 'هل نسيت كلمة المرور؟',
  'signin.new': 'ليس لديك حساب؟',
  'signin.create': 'إنشاء حساب',
  'signin.enterCode': 'إدخال الرمز',
  'code.title': 'رمز تسجيل الدخول',
  'code.lead': 'يُرجى فتح تطبيق المصادقة وإدخال الرمز المكوّن من 6 أرقام الظاهر لـ PathsAbroad.',
  'code.label': 'الرمز المكوّن من 6 أرقام',
  'code.switch': 'استخدام حساب آخر',
  'code.help': 'فقدت هاتفك؟ يُرجى مراسلتنا على {email} من البريد الذي سجّلت به.',

  'reset.title': 'إعادة تعيين كلمة المرور',
  'reset.lead': 'يُرجى إدخال بريدك الإلكتروني المستخدم في PathsAbroad، وسنرسل إليك رمزًا مكوّنًا من 6 أرقام.',
  'reset.send': 'إرسال الرمز',
  'reset.sent': 'إن وُجد حساب مرتبط بالبريد {email}، فقد أرسلنا إليه رمزًا مكوّنًا من 6 أرقام.',
  'reset.newPassword': 'كلمة المرور الجديدة',
  'reset.submit': 'تعيين كلمة المرور الجديدة',
  'reset.otherEmail': 'استخدام بريد إلكتروني آخر',
  'reset.back': 'العودة إلى تسجيل الدخول',

  'gn.title': 'نحتاج إلى موافقة وليّ أمرك',
  'gn.lead': 'لأن عمرك أقل من 18 عامًا، يلزم أن يوافق أحد والديك أو وصيّك القانوني قبل أن يحفظ PathsAbroad أي شيء عنك، مثل ملفك الشخصي أو قائمة جامعاتك أو مستنداتك.',
  'gn.whatTitle': 'على ماذا يوافق',
  'gn.what1': 'أن يحفظ PathsAbroad ملفك الشخصي ويستخدمه لمساعدتك في طلبات التقديم.',
  'gn.what2': 'أن يكون بإمكانك استخدام المخطِّط وبريد الطلبات وإضافة كروم.',
  'gn.what3': 'لن نطلب منك بيانات حساسة مثل الدين أو دخل الأسرة ما دمت دون 18 عامًا.',
  'gn.howTitle': 'كيف تتم الموافقة',
  'gn.how1': 'نرسل رابطًا إلى عنوان البريد المُدخل أدناه.',
  'gn.how2': 'توضّح الصفحة ما نحفظه ولماذا، ويمكنه أن يوافق أو يرفض.',
  'gn.how3': 'إذا وافق، يُفتح حسابك بالكامل. ويمكنه التراجع لاحقًا، وعندها يُحذف حسابك.',
  'gn.whyTitle': 'لماذا نطلب ذلك',
  'gn.why': 'تحمي القوانين في دول كثيرة من هم دون 18 عامًا على الإنترنت، وطلب موافقة وليّ الأمر يُبقيكما على اطلاع معًا.',
  'gn.formTitle': 'إرسال الطلب',
  'gn.email': 'البريد الإلكتروني لوليّ الأمر',
  'gn.lang': 'لغة الرسالة المرسلة إليه',
  'gn.submit': 'إرسال الطلب',
  'gn.sameEmail': 'يُرجى استخدام البريد الإلكتروني الخاص بوليّ أمرك، لا بريدك أنت.',
  'gn.sent': 'أُرسل الطلب إلى {email}.',
  'gn.rateLimited': 'يمكنك إرسال 3 طلبات في اليوم كحد أقصى. يُرجى المحاولة غدًا.',
  'gn.pending.title': 'بانتظار الرد',
  'gn.pending.text': 'أرسلنا رسالة إلى وليّ أمرك. يعمل الرابط لمدة 14 يومًا، وتتحدّث هذه الصفحة تلقائيًا.',
  'gn.check': 'التحقق الآن',
  'gn.resend': 'إعادة الإرسال',
  'gn.granted.title': 'وافق وليّ أمرك',
  'gn.granted.text': 'حسابك جاهز الآن. يمكنك حفظ ملفك الشخصي واستخدام كل ما يقدّمه PathsAbroad.',
  'gn.granted.go': 'الانتقال إلى حسابك',
  'gn.denied.title': 'لم يوافق وليّ أمرك',
  'gn.denied.text': 'يمكنك التحدث معه وإرسال طلب جديد، أو طلب الموافقة من وليّ أمر آخر.',
  'gn.expired.title': 'انتهت صلاحية الرابط',
  'gn.expired.text': 'لم يصل أي رد خلال 14 يومًا. يمكنك إرسال طلب جديد أدناه.',
  'gn.revoked.title': 'سُحبت الموافقة',
  'gn.revoked.text': 'سحب وليّ أمرك موافقته.',
  'gn.limited': 'وحتى ذلك الحين، يمكنك قراءة إشعار الخصوصية وشروط الاستخدام، أو تسجيل الخروج.',

  'gc.title': 'طلب أحد الطلاب موافقتك',
  'gc.lead': 'يرغب صاحب الحساب {student} في استخدام PathsAbroad. ولأن عمره أقل من 18 عامًا، نحتاج أولًا إلى موافقة أحد والديه أو وصيّه القانوني.',
  'gc.aboutTitle': 'ما هو PathsAbroad',
  'gc.about': 'يساعد PathsAbroad الطلاب على اختيار الجامعات في الخارج، وتجهيز طلبات التقديم، والاستعداد للتأشيرة بمعلومات من مصادر رسمية، ثم الاستقرار. والطالب هو من يرسل كل طلب ويدفع أي رسوم دراسية بنفسه. كما أن PathsAbroad ليس جامعة ولا وكيلًا ولا مستشار هجرة.',
  'gc.storeTitle': 'ما نحفظه عن الطالب',
  'gc.store1': 'ملفه الشخصي لطلبات التقديم: الأسماء وتاريخ الميلاد والجنسية وبيانات التواصل والمدارس والدرجات وبيانات الأسرة وخطط الدراسة. ويُشفَّر تاريخ الميلاد والجنسية ورقم جواز السفر إن وُجد.',
  'gc.store2': 'البيانات الحساسة مثل الأصل العرقي أو الدين أو دخل الأسرة: لا نجمعها أبدًا ما دام دون 18 عامًا. وبعد بلوغه 18 عامًا، يمكنه أن يختار إضافة كل منها على حدة، لمطابقة المنح فقط.',
  'gc.store3': 'ملخصات بريد الطلبات: إذا استخدم بريد الطلبات في PathsAbroad، نحتفظ بملخصات قصيرة لرسائل القبول، ونحتفظ بالرسائل الكاملة ما دامت باقته سارية، و30 يومًا على الأقل، ثم نحذفها.',
  'gc.store4': 'المدفوعات: إذا اشتُريت باقة مدفوعة، تتولى Stripe بيانات البطاقة، ولا نرى رقم البطاقة أبدًا.',
  'gc.store5': 'لا إعلانات ولا تتبّع، ولا نبيع البيانات أبدًا.',
  'gc.rightsTitle': 'حقوقك',
  'gc.rights1': 'الاطلاع على بيانات الطالب أو تنزيلها، أو طلب تصحيحها أو حذفها، بمراسلتنا على {email}.',
  'gc.rights2': 'سحب موافقتك في أي وقت. بعد موافقتك، نرسل إليك رابطًا منفصلًا لذلك. ويؤدي السحب إلى حذف حساب الطالب وبياناته.',
  'gc.rights3': 'تقديم شكوى إلى هيئة حماية البيانات في بلدك إذا رأيت أننا أخطأنا في شيء.',
  'gc.formTitle': 'قرارك',
  'gc.name': 'اسمك الكامل',
  'gc.relationship': 'صلتك بالطالب',
  'gc.confirm': 'أُقرّ بأنني أحد والدي هذا الطالب أو وصيّه القانوني، وأن عمري 18 عامًا أو أكثر',
  'gc.agree': 'أوافق',
  'gc.decline': 'لا أوافق',
  'gc.ignore': 'لست الشخص المعني؟ يمكنك تجاهل هذا الطلب، إذ تنتهي صلاحيته في {date}.',
  'gc.missing': 'تحتاج هذه الصفحة إلى الرابط الوارد في الرسالة التي أرسلناها.',
  'gc.invalid.title': 'هذا الرابط غير صالح',
  'gc.invalid.text': 'ربما حلّ محله طلب أحدث. ويمكن للطالب إرسال طلب جديد.',
  'gc.granted.title': 'شكرًا لك، تمت الموافقة.',
  'gc.granted.text': 'يمكن لصاحب الحساب {student} الآن استخدام PathsAbroad. وأرسلنا إليك رابطًا منفصلًا يمكنك استخدامه لسحب موافقتك في أي وقت.',
  'gc.denied.title': 'تم رفض الطلب',
  'gc.denied.text': 'لن يحفظ PathsAbroad أي بيانات إضافية عن الطالب، وسيبقى حسابه محدودًا ما لم يوافق أحد والديه أو وصيّه القانوني.',
  'gc.already.granted': 'سبق أن وافقت على هذا الطلب. لسحب الموافقة، يمكنك استخدام الرابط الوارد في الرسالة التي أرسلناها بعد موافقتك.',
  'gc.already.denied': 'سبق أن رفضت هذا الطلب.',
  'gc.already.expired': 'انتهت صلاحية هذا الطلب، ويمكن للطالب إرسال طلب جديد.',
  'gc.already.revoked': 'سُحبت الموافقة على هذا الحساب.',

  'gw.title': 'سحب موافقتك',
  'gw.lead': 'عند سحب موافقتك، نحذف حساب الطالب في PathsAbroad وجميع بياناته: الملف الشخصي وقائمة الجامعات والمقالات وبريد الطلبات والرسائل والمهام. ولا يمكن التراجع عن ذلك.',
  'gw.kept': 'تحتفظ Stripe بسجلات أي مدفوعات للمدة التي يفرضها قانون الضرائب. ونحتفظ بسجل يفيد بحذف الحساب دون أي بيانات شخصية.',
  'gw.confirm': 'أدرك أن هذا يحذف حساب الطالب وبياناته',
  'gw.submit': 'سحب الموافقة وحذف الحساب',
  'gw.done.title': 'تم سحب الموافقة',
  'gw.done.text': 'حذفنا حساب الطالب وبياناته، وأرسلنا إليكما رسالة تأكيد.',
  'gw.invalid': 'هذا الرابط غير صالح أو سبق استخدامه.',

  'rel.mother': 'الأم',
  'rel.father': 'الأب',
  'rel.guardian': 'الوصي القانوني',
  'rel.other': 'صلة أخرى',
  'edu.none': 'بلا تعليم نظامي',
  'edu.primary': 'المرحلة الابتدائية',
  'edu.secondary': 'المرحلة الثانوية',
  'edu.some_university': 'دراسة جامعية غير مكتملة',
  'edu.bachelor': 'البكالوريوس',
  'edu.master': 'الماجستير',
  'edu.doctorate': 'الدكتوراه',
  'edu.unknown': 'لا أعرف',

  'acct.greeting': 'مرحبًا، {name}',
  'acct.greetingNoName': 'أهلًا بعودتك',
  'acct.hero.title': 'المتابعة من حيث توقفت',
  'acct.hero.text': 'قائمة جامعاتك وقائمة متطلبات التأشيرة ومتابعة التمويل، كلها في المخطِّط.',
  'acct.status': 'الحالة',
  'acct.consent': 'موافقة وليّ الأمر',
  'acct.consentGranted': 'تمت الموافقة',
  'acct.freePlan': 'الباقة المجانية',
  'acct.seePlans': 'عرض الباقات',
  'acct.pass': 'باقة {plan}',
  'acct.validUntil': 'صالحة حتى {date}',
  'acct.mfa': 'التحقق بخطوتين',
  'acct.mfaNudge': 'ننصحك بتفعيل التحقق بخطوتين، حتى لا تكفي كلمة مرور مسروقة للدخول إلى حسابك.',
  'acct.inbox': 'بريد الطلبات',
  'acct.inboxNone': 'الحصول على عنوانك',
  'acct.withApply': 'ضمن باقة التقديم والوصول',
  'acct.extension': 'إضافة كروم',
  'acct.extensionOn': 'متصلة',
  'acct.extensionAdd': 'الإضافة إلى Chrome',
  'acct.extensionSetUp': 'الإعداد',
  'acct.you': 'حسابك',
  'acct.groupApply': 'التقديم',
  'acct.groupYou': 'أنت وخطتك',
  'acct.groupSafety': 'الخصوصية والأمان',
  'acct.groupPlanner': 'في المخطِّط',
  'acct.profileSub': 'بياناتك التي تُملأ في طلباتك',
  'acct.familySub': 'صفحة متابعة للأهل، ودفع الأهل',
  'acct.dataSub': 'تنزيل كل شيء أو حذفه',
  'acct.mfaShort': 'التحقق بخطوتين',
  'acct.tools': 'الأدوات والإعدادات',
  'acct.toolsSub': 'خطة الدراسة والمستندات والمواعيد والتدريب على اللغة والمظهر الفاتح أو الداكن',
  'portal.label': 'القائمة الرئيسية',
  'portal.home': 'الرئيسية',
  'portal.explore': 'استكشف',
  'portal.apply': 'التقديم',
  'portal.account': 'الحساب',
  'acct.apps': 'طلبات التقديم',
  'acct.appsEmpty': 'ستظهر طلباتك هنا بعد إضافة الجامعات في المخطِّط.',
  'acct.submitted': 'أُرسل في {date}',
  'acct.tasks': 'المهام',
  'acct.tasksEmpty': 'لا توجد مهام حاليًا.',
  'acct.due': 'الموعد النهائي: {date}',
  'acct.manage': 'حسابك',
  'acct.loadError': 'تعذّر تحميل هذا الجزء. {retry}',
  'task.ai': 'ذكاء اصطناعي',
  'task.aiFull': 'اقترحها الذكاء الاصطناعي',
  'task.email': 'من بريد الطلبات',
  'task.error': 'تعذّر تحديث هذه المهمة. يُرجى المحاولة مرة أخرى.',
  'app.planned': 'مخطط له',
  'app.in_progress': 'قيد التجهيز',
  'app.submitted': 'تم الإرسال',
  'app.decision_admitted': 'مقبول',
  'app.decision_denied': 'غير مقبول',
  'app.decision_waitlisted': 'على قائمة الانتظار',
  'app.decision_deferred': 'مؤجَّل',
  'app.accepted': 'تم قبول العرض',
  'app.declined': 'تم رفض العرض',
  'app.withdrawn': 'تم سحب الطلب',

  'profile.title': 'الملف الشخصي',
  'profile.lead': 'يكفي ملؤه مرة واحدة. تستخدمه الإضافة لتعبئة بوابات التقديم، وتبقى مراجعة كل شيء قبل الإرسال بيدك.',
  'profile.sec.name': 'اسمك',
  'profile.nameNote': 'يُرجى كتابة الأسماء كما تظهر في جواز سفرك تمامًا.',
  'f.given_name': 'الاسم الأول',
  'f.middle_name': 'الاسم الأوسط',
  'f.family_name': 'اسم العائلة',
  'f.preferred_name': 'الاسم المفضّل',
  'profile.sec.about': 'معلومات عنك',
  'f.dob': 'تاريخ الميلاد',
  'f.gender': 'الجنس',
  'gender.female': 'أنثى',
  'gender.male': 'ذكر',
  'gender.another': 'هوية أخرى',
  'gender.none': 'أفضّل عدم الإجابة',
  'profile.sec.citizenship': 'الجنسية ومكان الإقامة',
  'f.citizenship1': 'الجنسية',
  'f.citizenship2': 'الجنسية الثانية',
  'f.birth_country': 'بلد الميلاد',
  'f.home_country': 'بلد الإقامة',
  'f.home_countryHint': 'تعتمد عليه الأسعار وقوائم متطلبات التأشيرة.',
  'f.first_language': 'اللغة الأم',
  'profile.sec.contact': 'التواصل',
  'f.phone': 'الهاتف',
  'f.phoneHint': 'يُرجى تضمين رمز الدولة، مثل ⁦+971⁩.',
  'f.line1': 'العنوان، السطر الأول',
  'f.line2': 'العنوان، السطر الثاني',
  'f.city': 'المدينة',
  'f.region': 'الولاية أو المحافظة أو المنطقة',
  'f.postal_code': 'الرمز البريدي',
  'f.country': 'البلد',
  'profile.sec.study': 'خطط الدراسة',
  'f.level': 'المرحلة الدراسية',
  'level.foundation': 'السنة التأسيسية',
  'level.diploma': 'الدبلوم أو الشهادة',
  'level.bachelor': 'البكالوريوس',
  'level.master': 'الماجستير',
  'level.phd': 'الدكتوراه',
  'f.field': 'التخصص',
  'f.start_term': 'موعد بدء الدراسة',
  'term.label': '{month} {year}',
  'f.budget_usd': 'الميزانية السنوية بالدولار الأمريكي',
  'f.budgetHint': 'الرسوم الدراسية وتكاليف المعيشة معًا.',
  'profile.sec.english': 'اللغة الإنجليزية',
  'f.english_first': 'الإنجليزية هي لغتي الأم',
  'f.english_type': 'اختبار اللغة الإنجليزية',
  'test.none': 'لم يُجرَ بعد',
  'test.other': 'اختبار آخر',
  'f.english_score': 'النتيجة',
  'f.english_date': 'تاريخ الاختبار',
  'profile.sec.passport': 'جواز السفر',
  'f.passport_number': 'رقم جواز السفر',
  'f.passportHint': 'اختياري. يُحفظ مشفّرًا، ولا تعبّئه الإضافة أبدًا.',
  'profile.sec.family': 'الأسرة',
  'profile.familyLead': 'كثيرًا ما تسأل بوابات التقديم عن والديك أو أولياء أمرك.',
  'profile.familyItem': 'وليّ الأمر {n}',
  'f.member_name': 'الاسم',
  'f.relation': 'صلة القرابة',
  'f.education': 'أعلى مستوى تعليمي',
  'f.occupation': 'المهنة',
  'profile.familyAdd': 'إضافة أحد الوالدين أو وليّ الأمر',
  'profile.sec.schools': 'المدارس',
  'profile.schoolsLead': 'مدرستك الثانوية وأي جامعة درست فيها.',
  'profile.schoolItem': 'المدرسة {n}',
  'f.school_name': 'اسم المدرسة',
  'f.start_date': 'تاريخ البدء',
  'f.end_date': 'تاريخ الانتهاء أو التاريخ المتوقع',
  'f.test_type': 'الامتحان النهائي أو الشهادة',
  'f.test_typeHint': 'مثل WAEC أو CBSE أو IGCSE أو التوجيهي.',
  'f.test_score': 'النتيجة',
  'profile.schoolAdd': 'إضافة مدرسة',
  'profile.schoolNameRequired': 'يُرجى إضافة اسم المدرسة أو حذفها.',
  'profile.sec.sensitive': 'مطابقة المنح',
  'profile.sensitiveLead': 'اختياري. بعض المنح مخصصة لطلاب من خلفيات معينة، ويمكنك اختيار مشاركة كل من هذه البيانات على حدة.',
  'profile.sensitivePurpose': 'تُستخدم فقط لمطابقتك مع المنح التي تطلبها، ولا تُرسل أبدًا إلى بوابات التقديم ولا تُستخدم للتسويق.',
  'profile.consent.race': 'استخدام أصلي العرقي لمطابقة المنح',
  'profile.consent.religion': 'استخدام ديانتي لمطابقة المنح',
  'profile.consent.family_income': 'استخدام دخل أسرتي لمطابقة المنح',
  'f.race': 'العِرق أو الأصل العرقي',
  'f.religion': 'الديانة',
  'f.family_income': 'دخل الأسرة السنوي بالدولار الأمريكي',
  'income.lt10k': 'أقل من 10,000 دولار',
  'income.10k_25k': 'من 10,000 إلى 25,000 دولار',
  'income.25k_50k': 'من 25,000 إلى 50,000 دولار',
  'income.50k_100k': 'من 50,000 إلى 100,000 دولار',
  'income.gt100k': 'أكثر من 100,000 دولار',
  'profile.sensitiveCleared': 'سيُحذف هذا البيان عند الحفظ.',
  'profile.sensitiveMinor': 'غير متاح للطلاب دون 18 عامًا.',
  'profile.sec.lang': 'اللغة',
  'f.lang': 'لغة الرسائل',
  'profile.saved': 'تم حفظ ملفك الشخصي.',
  'profile.unsaved': 'لديك تغييرات غير محفوظة.',

  'inbox.title': 'بريد الطلبات',
  'inbox.lead': 'عنوان بريد خاص بطلبات التقديم. تُرتَّب هنا رسائل القبول المرسلة إليه، مع استخراج المواعيد والخطوات التالية. وحين ترسل جامعة قرارًا أو تطلب شيئًا، نرسل إليك بريدًا إلكترونيًا.',
  'inbox.upsellTitle': 'ضمن باقة التقديم والوصول',
  'inbox.upsellText': 'مع باقة التقديم والوصول يصبح لديك عنوان من PathsAbroad لاستخدامه في بوابات التقديم، وتُرتَّب كل رسائل القبول في مكان واحد.',
  'inbox.seePlans': 'عرض الباقات',
  'inbox.address': 'عنوان بريدك للطلبات',
  'inbox.copy': 'نسخ العنوان',
  'inbox.howTitle': 'أين يُستخدم',
  'inbox.how1': 'استخدامه بريدًا إلكترونيًا في بوابات التقديم، مثل Common App. وإضافة PathsAbroad تعبّئه نيابةً عنك.',
  'inbox.how2': 'الإبقاء على بريدك الشخصي لكل ما عدا ذلك.',
  'inbox.how3': 'تُحفظ الرسائل الكاملة ما دامت باقتك سارية، ولمدة 30 يومًا على الأقل، ثم نحتفظ بملخص قصير والمواعيد والروابط والإجراءات. ولا نحتفظ بالمرفقات، فنزّل المستندات من بوابة الجامعة.',
  'inbox.messages': 'الرسائل',
  'inbox.empty': 'لا توجد رسائل قبول بعد. ستظهر هنا فور وصول أي رسالة.',
  'inbox.received': 'وصلت في {date}',
  'inbox.dates': 'المواعيد',
  'inbox.links': 'الروابط',
  'inbox.actions': 'المطلوب منك',
  'inbox.viewFull': 'عرض الرسالة كاملة',
  'inbox.hideFull': 'إخفاء الرسالة الكاملة',
  'inbox.fullGone': 'حُذفت الرسالة الكاملة.',
  'inbox.fullExpires': 'ستُحذف هذه الرسالة الكاملة في {date}.',
  'inbox.from': 'من',
  'inbox.subject': 'الموضوع',
  'cat.decision': 'قرار',
  'cat.interview_invite': 'مقابلة',
  'cat.missing_documents': 'مستندات ناقصة',
  'cat.financial_aid': 'مساعدة مالية',
  'cat.portal_credentials': 'الدخول إلى البوابة',
  'cat.submission_confirmation': 'تأكيد الإرسال',
  'cat.housing': 'السكن',
  'cat.visa_documents': 'مستندات التأشيرة',
  'cat.other': 'أخرى',
  'decision.admitted': 'مقبول',
  'decision.denied': 'غير مقبول',
  'decision.waitlisted': 'على قائمة الانتظار',
  'decision.deferred': 'مؤجَّل',

  'plans.title': 'الباقات',
  'plans.lead': 'دفعة واحدة لكل موسم، بلا اشتراك.',
  'plans.oneTime': 'دفعة واحدة لهذا الموسم، بلا تجديد تلقائي.',
  'plans.validFor': 'صالحة لمدة {months} من يوم الدفع.',
  'plans.free': 'ما لديك الآن',
  'plans.freeTitle': 'كل شيء مجاني',
  'plans.freeLead': 'كل ما في PathsAbroad مجاني لك. تدفع لنا الجامعات وخدمات الطلاب عندما يلتحق طالب أو يسجّل، ولا يدفع الطلاب أبدًا.',
  'plans.get': 'الحصول على باقة {plan}',
  'plans.owned': 'لديك هذه الباقة حتى {date}',
  'plans.ownedNoDate': 'لديك هذه الباقة',
  'plans.bundlePartial': 'لديك باقة {plan} بالفعل، وتضيف باقة التقديم والوصول كل ما عداها.',
  'plans.redirecting': 'جارٍ نقلك إلى صفحة الدفع الآمنة…',
  'plans.refund': 'كل المبيعات نهائية ولا يُسترد ثمنها. تنتقل باقتك إلى الموسم التالي إن لم يصلك أي عرض قبول.',
  'plans.startNowTitle': 'قبل الشراء',
  'plans.startNow': 'ابدأ باقتي فور الدفع. أفهم أن كل المبيعات نهائية: بعد أن تبدأ، لا يمكنني إلغاؤها أو استرداد ثمنها.',
  'plans.startNowNote': 'إن لم يصلك أي عرض قبول، تنتقل باقتك إلى الموسم التالي مجانًا.',
  'plans.prices': 'الأسعار بالدولار الأمريكي، وتُحدَّد حسب بلد إقامتك ودول جوازات سفرك (فئة الأسعار {tier}).',
  'plans.noFees': 'لا يحصّل PathsAbroad أبدًا رسوم الجامعات أو الاختبارات أو التأشيرات، فهذه تُدفع منك مباشرة.',
  'plans.paidTitle': 'شكرًا لك، تمّ الدفع بنجاح.',
  'plans.paidWaiting': 'جارٍ إضافة باقتك، ويستغرق ذلك عادةً بضع ثوانٍ.',
  'plans.paidReady': 'باقة {plan} جاهزة.',
  'plans.paidEmail': 'رسالة التأكيد في طريقها إلى بريدك.',
  'plans.paidSlow': 'يستغرق الأمر وقتًا أطول من المعتاد. دفعتك في أمان، وستظهر باقتك هنا قريبًا. يمكنك إعادة تحميل الصفحة بعد دقيقة.',
  'plans.canceled': 'أُلغيت عملية الدفع، ولم يُخصم منك أي مبلغ.',
  'plans.receipts': 'الإيصالات والفواتير',
  'plans.yourPasses': 'باقاتك',
  'plans.choose': 'اختيار باقة',
  'pass.active': 'سارية',
  'pass.expired': 'منتهية',
  'pass.refunded': 'مستردّة',
  'pass.canceled': 'ملغاة',
  'pass.paidOn': 'دُفعت في {date}',
  'pass.validUntil': 'صالحة حتى {date}',
  'pass.withdrawUntil': 'يمكنك الانسحاب واسترداد المبلغ كاملًا حتى {date}.',
  'pass.withdraw': 'الانسحاب من العقد هنا',
  'pass.confirmTitle': 'الانسحاب من هذا العقد؟',
  'pass.confirmRefund': 'يُردّ إليك المبلغ كاملًا على وسيلة الدفع الأصلية.',
  'pass.confirmAccess': 'ينتهي وصولك إلى باقة {plan} فورًا.',
  'pass.confirmReceipt': 'سنرسل إليك إيصالًا مؤرَّخًا بالبريد الإلكتروني.',
  'pass.confirm': 'تأكيد الانسحاب',
  'pass.keep': 'الإبقاء على باقتي',
  'pass.withdrawn': 'أُعيد المبلغ في {date}، وهو في طريقه إلى وسيلة الدفع الأصلية.',
  'pass.withdrawOver': 'كل المبيعات نهائية: لا يمكن الانسحاب من هذه الباقة أو استرداد ثمنها.',
  'ai.tag': 'ذكاء اصطناعي',
  'ai.tagFull': 'يعمل بالذكاء الاصطناعي',

  'ext.title': 'إضافة كروم',
  'ext.lead': 'تعبّئ إضافة PathsAbroad إجاباتك المحفوظة في بوابات التقديم، فيكفي أن تُكتب مرة واحدة.',
  'ext.upsell': 'تأتي الإضافة مع باقة التقديم والوصول.',
  'ext.howTitle': 'طريقة العمل',
  'ext.how1': 'إضافتها إلى Chrome من سوق Chrome الإلكتروني بنقرة واحدة.',
  'ext.how2': 'تتصل تلقائيًا ما دام الحساب مسجَّل الدخول في PathsAbroad على المتصفح نفسه، وينقطع اتصالها عند تسجيل الخروج.',
  'ext.how3': 'في صفحة الطلب، الضغط على «املأ باستخدام PathsAbroad»، ثم مراجعة كل حقل وإرسال الطلب.',
  'ext.checking': 'جارٍ البحث عن الإضافة…',
  'ext.connecting': 'جارٍ ربطها بالحساب…',
  'ext.addTitle': 'إضافة PathsAbroad إلى Chrome',
  'ext.addText': 'نقرة واحدة في سوق Chrome الإلكتروني، ثم تتصل الإضافة بالحساب تلقائيًا، دون أي رمز.',
  'ext.addButton': 'الإضافة إلى Chrome',
  'ext.addSoon': 'ستتوفر الإضافة قريبًا في سوق Chrome الإلكتروني.',
  'ext.browsers': 'تعمل في Chrome و Edge و Brave وغيرها من المتصفحات المبنية على Chromium، على الكمبيوتر.',
  'ext.onTitle': 'متصلة في هذا المتصفح',
  'ext.onText': 'عند فتح الطلب على Common App أو UCAS أو OUAC أو uni-assist، يظهر زر «املأ باستخدام PathsAbroad» أسفل الصفحة.',
  'ext.onInstalled': 'تم تثبيت PathsAbroad وربطه.',
  'ext.onBack': 'يمكن الآن العودة إلى صفحة الطلب.',
  'ext.connected': 'متصلة',
  'ext.errTitle': 'لم تتصل الإضافة',
  'ext.errText': 'يُرجى المحاولة مرة أخرى. وإن لم تتصل، يمكن استخدام رمز الربط أدناه.',
  'ext.retry': 'إعادة المحاولة',
  'ext.phoneTitle': 'على الهاتف: تطبيق PathsAbroad',
  'ext.phoneText': 'يفتح التطبيق صفحة الطلب داخله ويملؤها. أما على الكمبيوتر فتُستخدم إضافة Chrome.',
  'ext.appStore': 'التنزيل من App Store',
  'ext.playStore': 'التنزيل من Google Play',
  'ext.appSoon': 'سيتوفر التطبيق قريبًا في App Store و Google Play.',
  'ext.otherTitle': 'فتح PathsAbroad في Chrome أو Edge',
  'ext.otherText': 'تعمل الإضافة في Chrome و Edge وغيرها من المتصفحات المبنية على Chromium. يُرجى فتح PathsAbroad في أحدها لإضافتها.',
  'ext.inAppTitle': 'هذا تطبيق PathsAbroad',
  'ext.inAppText': 'تُفتح صفحة الطلب من المخطِّط داخل التطبيق، ومعها زر «املأ باستخدام PathsAbroad». لا حاجة إلى الإضافة هنا.',
  'ext.fillButton': 'املأ باستخدام PathsAbroad',
  'ext.codeTitle': 'الربط برمز',
  'ext.codeLead': 'فقط إذا لم تتصل الإضافة تلقائيًا',
  'ext.step2': 'الضغط على «الحصول على رمز الربط» أدناه.',
  'ext.step3': 'فتح الإضافة وإدخال الرمز خلال 10 دقائق.',
  'ext.getCode': 'الحصول على رمز الربط',
  'ext.newCode': 'الحصول على رمز جديد',
  'ext.code': 'رمز الربط',
  'ext.copy': 'نسخ الرمز',
  'ext.expiresIn': 'تنتهي صلاحيته خلال {time}',
  'ext.expired': 'انتهت صلاحية هذا الرمز. يمكنك الحصول على رمز جديد.',
  'ext.oneUse': 'يعمل كل رمز مرة واحدة فقط.',
  'ext.minuteLeft': 'بقيت دقيقة واحدة لاستخدام هذا الرمز.',
  'ext.rulesTitle': 'ما تفعله الإضافة وما لا تفعله',
  'ext.rule1': 'تعبّئ إجاباتك المحفوظة في بوابات التقديم المدعومة: Common App و UCAS و OUAC و uni-assist.',
  'ext.ruleEmail': 'في خانة البريد الإلكتروني تكتب عنوان بريد الطلبات الخاص بك في PathsAbroad، فتصل رسائل الجامعات إلى بريد الطلبات.',
  'ext.rule2': 'مراجعة كل حقل وإرسال الطلب يبقيان بيدك.',
  'ext.rule3': 'لا تعبّئ المقالات ولا كلمات المرور أبدًا.',
  'ext.rule4': 'لا تضغط أبدًا على أزرار الإرسال أو الدفع.',
  'ext.rule5': 'لا تعمل في مواقع التأشيرات والمواقع الحكومية.',
  'ext.notAffiliated': 'لا يرتبط PathsAbroad بـ Common App ولا بـ UCAS ولا بـ OUAC ولا بـ uni-assist ولا بأي جامعة.',

  'sec.title': 'تسجيل الدخول والأمان',
  'sec.mfaTitle': 'التحقق بخطوتين',
  'sec.mfaOffText': 'عند تفعيله، يُطلب منك رمز من تطبيق المصادقة عند كل تسجيل دخول، فلا تكفي كلمة مرور مسروقة للدخول.',
  'sec.mfaOnText': 'يُطلب منك رمز من تطبيق المصادقة عند كل تسجيل دخول.',
  'sec.mfaTurnOn': 'تفعيل التحقق بخطوتين',
  'sec.mfaStep1': 'تثبيت تطبيق مصادقة، مثل Google Authenticator أو Microsoft Authenticator أو 1Password.',
  'sec.mfaStep2': 'مسح رمز QR هذا بالتطبيق.',
  'sec.mfaQr': 'رمز QR لتطبيق المصادقة',
  'sec.mfaOpenApp': 'على هذا الهاتف؟ فتحه في تطبيق المصادقة',
  'sec.mfaKey': 'إذا تعذّر المسح، يمكنك إدخال هذا المفتاح في التطبيق:',
  'sec.mfaCopyKey': 'نسخ المفتاح',
  'sec.mfaStep3': 'إدخال الرمز المكوّن من 6 أرقام الذي يظهر في التطبيق.',
  'sec.mfaVerify': 'تفعيل',
  'sec.mfaEnabled': 'التحقق بخطوتين مفعّل.',
  'sec.mfaTurnOff': 'إيقاف',
  'sec.mfaConfirmOff': 'إيقاف التحقق بخطوتين؟ عندها تكفي كلمة المرور وحدها لتسجيل الدخول.',
  'sec.mfaKeepOn': 'إبقاؤه مفعّلًا',
  'sec.mfaDisabled': 'التحقق بخطوتين غير مفعّل.',
  'sec.pwTitle': 'كلمة المرور',
  'sec.pwNew': 'كلمة المرور الجديدة',
  'sec.pwConfirm': 'إعادة كتابة كلمة المرور',
  'sec.pwSubmit': 'تغيير كلمة المرور',
  'sec.pwDone': 'تم تغيير كلمة المرور.',
  'sec.signoutTitle': 'تسجيل الخروج',
  'sec.signoutText': 'تسجيل الخروج من PathsAbroad في هذا المتصفح.',

  'data.title': 'بياناتك',
  'data.lead': 'يمكنك الاطلاع على ما نحتفظ به عنك، وأخذ نسخة منه، أو حذفه.',
  'data.exportTitle': 'تنزيل بياناتي',
  'data.exportText': 'ملف JSON واحد يضم كل ما نحتفظ به عنك: الملف الشخصي وطلبات التقديم وملخصات البريد والمهام والموافقات والمدفوعات.',
  'data.exportDone': 'بدأ التنزيل.',
  'data.deleteTitle': 'حذف حسابي',
  'data.deleteWhat': 'يُحذف ما يلي:',
  'data.delete1': 'حسابك وبيانات تسجيل الدخول',
  'data.delete2': 'ملفك الشخصي وبيانات أسرتك ومدارسك ومقالاتك',
  'data.delete3': 'المخطِّط وطلبات التقديم والمهام',
  'data.delete4': 'بريد الطلبات ورسائله',
  'data.delete5': 'سجلات الموافقة وروابط الإضافة',
  'data.deleteKept': 'تحتفظ Stripe بسجلات المدفوعات (المبلغ والتاريخ وآخر أربعة أرقام من البطاقة) وفقًا لما تفرضه قوانين الضرائب ومكافحة الاحتيال. ونحتفظ بسجل يفيد بحذف حساب ما، دون أي بيانات شخصية.',
  'data.deleteFinal': 'لا يمكن التراجع عن ذلك، لذا قد يكون من الأفضل تنزيل بياناتك أولًا.',
  'data.deleteType': 'للتأكيد، يُرجى كتابة DELETE',
  'data.deleteButton': 'حذف حسابي',
  'data.rightsTitle': 'حقوقك',
  'data.rightAccess': 'الحصول على نسخة من بياناتك عبر «تنزيل بياناتي».',
  'data.rightCorrect': 'تصحيحها بتعديل {profile}.',
  'data.rightDelete': 'حذفها عبر «حذف حسابي».',
  'data.rightWithdraw': 'سحب الموافقة بإلغاء تحديد أي من بيانات مطابقة المنح في ملفك الشخصي.',
  'data.rightObject': 'الاعتراض على طريقة استخدامنا لبياناتك أو تقييدها.',
  'data.rightPort': 'نقل بياناتك إلى خدمة أخرى: ملف التنزيل بصيغة JSON القياسية.',
  'data.rightComplain': 'تقديم شكوى إلى هيئة حماية البيانات في بلدك.',
  'data.contact': 'لأي سؤال أو طلب، يمكنك مراسلتنا على {email}. نرد خلال شهر واحد.',
  'data.profileLink': 'ملفك الشخصي',

  'bye.title': 'تم حذف حسابك',
  'bye.text': 'حذفنا حسابك في PathsAbroad وبياناتك. شكرًا لتجربتك PathsAbroad، ونتمنى لك التوفيق في دراستك.',
  'nf.title': 'لم نعثر على هذه الصفحة',
  'nf.text': 'ربما يكون الرابط معطّلًا، أو نُقلت الصفحة.',
  'legal.contents': 'المحتويات',
  'legal.effective': 'تاريخ السريان: {date}',
  'legal.top': 'العودة إلى الأعلى',

  /* AI: the AI guide and essay feedback */
  'err.ai_unavailable': 'الذكاء الاصطناعي غير متاح الآن. يُرجى المحاولة لاحقًا.',
  'aiCheck.title': 'هل كتب الذكاء الاصطناعي في PathsAbroad هذا النص؟',
  'aiCheck.lead': 'يمكن لصق نص للتحقق مما إذا كان إجابةً من المرشد الذكي أو من الملاحظات على المقالات في PathsAbroad. تحمل كل إجابة من الذكاء الاصطناعي علامة عند كتابتها، ونحتفظ ببصمة لها (وليس بالنص نفسه أبدًا).',
  'aiCheck.label': 'النص المطلوب التحقق منه',
  'aiCheck.hint': 'يُرجى لصق الإجابة كاملة كما ظهرت تمامًا. النص المعدَّل أو الجزئي لن يتطابق.',
  'aiCheck.empty': 'يُرجى لصق نص للتحقق منه.',
  'aiCheck.submit': 'التحقق',
  'aiCheck.yes.title': 'نعم: كتب الذكاء الاصطناعي في PathsAbroad هذا النص',
  'aiCheck.yes.text': 'يتطابق هذا النص مع إجابة من الذكاء الاصطناعي في PathsAbroad بتاريخ {date}.',
  'aiCheck.no.title': 'لا يوجد تطابق',
  'aiCheck.no.text': 'لا يتطابق هذا النص مع أي إجابة من الذكاء الاصطناعي في PathsAbroad. ربما كتبه إنسان، أو عُدِّل، أو كتبته أداة أخرى.',
  'aiCheck.how': 'طريقة العمل: تحمل كل إجابة من الذكاء الاصطناعي بيانات موقّعة (من كتبها، ومتى، وبصمة للنص). ويقارن هذا التحقق بصمة النص الملصق ببصمات إجابات الذكاء الاصطناعي في PathsAbroad، ولا يعرض أي شيء عن الطالب.',

  /* reminders: WhatsApp and email */
  'nav.reminders': 'التذكيرات',
  'rem.title': 'التذكيرات',
  'rem.lead': 'نرسل إليك بريدًا إلكترونيًا بالمواعيد النهائية ومواعيد الرد على عروض القبول والمستندات الناقصة والقرارات، ويمكنك تلقيها على واتساب أيضًا.',
  'rem.on': 'مفعّلة',
  'rem.waTitle': 'واتساب',
  'rem.waOff': 'تذكيرات واتساب غير متاحة بعد. التذكيرات بالبريد الإلكتروني متاحة الآن.',
  'rem.waOn': 'تصل التذكيرات إلى الرقم {phone} على واتساب.',
  'rem.waPhone': 'رقم واتساب',
  'rem.waPhoneHint': 'مع رمز الدولة، مثل: ‎+966 50 123 4567',
  'rem.waConsent': 'أوافق على أن يرسل لي PathsAbroad رسائل واتساب بخصوص طلباتي (المواعيد النهائية ومواعيد الرد على العروض والمستندات الناقصة والقرارات)، ورمزًا لتأكيد رقمي. ويمكنني الإيقاف في أي وقت بالرد بكلمة STOP.',
  'rem.waConsentNeeded': 'يُرجى تحديد المربع للموافقة على تذكيرات واتساب.',
  'rem.waSend': 'إرسال الرمز',
  'rem.waSent': 'أرسلنا رمزًا من 6 أرقام إلى {phone} على واتساب. الرمز صالح لمدة 10 دقائق.',
  'rem.waCode': 'الرمز الوارد على واتساب',
  'rem.waConfirm': 'تأكيد',
  'rem.waResend': 'إرسال رمز جديد',
  'rem.waOther': 'استخدام رقم آخر',
  'rem.waConfirmed': 'تم تشغيل تذكيرات واتساب، وأرسلنا رسالة أولى إلى {phone}.',
  'rem.waStop': 'إيقاف تذكيرات واتساب',
  'rem.waStopped': 'تم إيقاف تذكيرات واتساب وحذف رقمك.',
  'rem.waStoppedReply': 'تم إيقاف تذكيرات واتساب بالرد بكلمة STOP، وحذفنا رقمك.',
  'rem.waUnreachable': 'تعذّر على واتساب إيصال الرسائل إلى {phone}. يُرجى التحقق من الرقم وإعداده من جديد.',
  'rem.waChanged': 'تغيّر رقم واتساب، لذلك توقفت التذكيرات إلى {phone}. لمواصلة تلقيها، يُرجى إضافة الرقم الجديد.',
  'rem.phoneInvalid': 'يُرجى إدخال رقم واتساب مع رمز الدولة، مثل: ‎+966 50 123 4567',
  'rem.phoneNotMobile': 'يُرجى إدخال رقم جوال.',
  'rem.phoneNotWhatsApp': 'لا يمكن لهذا الرقم استقبال رسائل واتساب. يُرجى التحقق منه أو استخدام التذكيرات بالبريد الإلكتروني.',
  'rem.emailTitle': 'البريد الإلكتروني',
  'rem.emailLabel': 'إرسال التذكيرات إلى {email}',
  'rem.emailOnDone': 'تم تشغيل التذكيرات بالبريد الإلكتروني.',
  'rem.emailOffDone': 'تم إيقاف التذكيرات بالبريد الإلكتروني.',
  'rem.kindsTitle': 'موضوعات التذكير',
  'rem.kindDeadlines': 'المواعيد النهائية',
  'rem.kindDeadlinesDesc': 'المهام ذات الموعد المحدد ومواعيد المنح: قبلها بـ7 أيام و3 أيام ويوم واحد، وفي اليوم نفسه.',
  'rem.kindOffers': 'الرد على عروض القبول',
  'rem.kindOffersDesc': 'موعد قبول العرض أو الاعتذار عنه، كما ورد في رسائل القبول.',
  'rem.kindDocuments': 'المستندات الناقصة',
  'rem.kindDocumentsDesc': 'عندما تفيد جامعة بأن شيئًا ما ناقص في طلبك.',
  'rem.kindDecisions': 'القرارات',
  'rem.kindDecisionsDesc': 'عندما ترسل جامعة قرارًا. لا تذكر الرسالة مضمون القرار أبدًا.',
  'rem.when': 'تصل التذكيرات بين 09:00 و20:00 بتوقيتك ({tz}).',
  'rem.test': 'إرسال تذكير تجريبي',
  'rem.testSent': 'تم الإرسال. يُرجى التحقق من واتساب أو البريد الإلكتروني.',
  'rem.saved': 'تم الحفظ.',
  'rem.recentTitle': 'آخر التذكيرات',
  'rem.recentNone': 'لا توجد تذكيرات بعد.',
  'rem.kind.deadline': 'موعد نهائي',
  'rem.kind.offer_reply': 'الرد على عرض',
  'rem.kind.missing_documents': 'مستندات ناقصة',
  'rem.kind.decision': 'قرار',
  'rem.kind.scholarship': 'موعد منحة',
  'rem.kind.test': 'تجربة',
  'rem.status.queued': 'قيد الإرسال',
  'rem.status.sent': 'أُرسل',
  'rem.status.delivered': 'وصل',
  'rem.status.read': 'قُرئ',
  'rem.status.failed': 'لم يصل',
  'rem.channel.whatsapp': 'واتساب',
  'rem.channel.email': 'البريد الإلكتروني',
  'rem.privacy': 'تُرسل رسائل واتساب عبر منصة WhatsApp Business من Meta. نخزّن رقمك مشفّرًا ونحذفه عند الإيقاف. التفاصيل في {privacy}.',
  'rem.privacyLink': 'إشعار الخصوصية',
  'rem.parentsTitle': 'أولياء الأمور على واتساب',
  'rem.parentsLead': 'يمكن لولي الأمر الذي تُشارَك معه صفحة المتابعة إضافة رقم واتساب الخاص به من تلك الصفحة. تقتصر تذكيراته على ما تعرضه الصفحة، وإيقاف الصفحة يوقف تذكيراته أيضًا.',
  'rem.parentRow': 'ولي الأمر ({label})',
  'rem.parentRowNoLabel': 'ولي الأمر',
  'rem.parentPending': 'بانتظار الرمز',
  'rem.parentStop': 'إيقاف',
  'rem.parentStoppedDone': 'تم الإيقاف وحُذف الرقم.',
  'rem.parentLinkStopped': 'توقف مع صفحة المتابعة',

  /* parents: progress page and "parent pays" */
  'nav.family': 'العائلة',
  'fam.title': 'العائلة',
  'fam.lead': 'مشاركة تقدّمك مع أحد الوالدين، وإرسال رابط ليدفع شخص آخر ثمن باقة. أنت من يحدّد ما يظهر، ويمكن إيقاف المشاركة في أي وقت.',
  'fam.share.title': 'مشاركة تقدّمك',
  'fam.share.sees': 'ما يظهر في الصفحة',
  'fam.share.see1': 'جامعاتك والمرحلة التي بلغها كل طلب.',
  'fam.share.see2': 'المواعيد النهائية القادمة، عند تفعيلها.',
  'fam.share.see3': 'قرارات القبول، عند تفعيلها.',
  'fam.share.see4': 'الباقات التي لديك.',
  'fam.share.never': 'لا تظهر أبدًا مقالاتك أو رسائلك أو ملفك الشخصي أو بيانات جواز سفرك أو محادثاتك، ولا يمكن تغيير أي شيء من الصفحة.',
  'fam.form.lang': 'لغة الصفحة',
  'fam.form.label': 'لمن هذا الرابط؟',
  'fam.form.labelHint': 'لا يظهر هذا إلا لك، مثل: أمي أو أبي.',
  'fam.form.deadlines': 'إظهار المواعيد النهائية القادمة',
  'fam.form.deadlinesNote': 'عناوين مهامك المفتوحة التي لها موعد نهائي.',
  'fam.form.decisions': 'إظهار قرارات القبول',
  'fam.form.decisionsNote': 'العروض والرفض وقوائم الانتظار. عند إيقاف هذا الخيار، تظهر الطلبات التي صدر فيها قرار على أنها مُرسلة.',
  'fam.form.create': 'إنشاء رابط',
  'fam.created': 'الرابط جاهز للإرسال.',
  'fam.links.title': 'روابطك',
  'fam.links.empty': 'لا توجد روابط بعد.',
  'fam.link.view': 'صفحة التقدّم',
  'fam.link.pay': 'رابط دفع: {plan}',
  'fam.link.for': 'المستلم: {label}',
  'fam.link.inLang': 'باللغة: {language}',
  'fam.link.until': 'يعمل حتى {date}',
  'fam.link.opened': 'آخر فتح: {date}',
  'fam.link.notOpened': 'لم يُفتح بعد',
  'fam.link.status.active': 'نشط',
  'fam.link.status.used': 'مدفوع',
  'fam.link.status.expired': 'منتهي الصلاحية',
  'fam.link.status.revoked': 'متوقف',
  'fam.link.copy': 'نسخ الرابط',
  'fam.link.whatsapp': 'إرسال عبر واتساب',
  'fam.link.email': 'إرسال بالبريد الإلكتروني',
  'fam.link.stop': 'إيقاف المشاركة',
  'fam.link.cancel': 'إلغاء الرابط',
  'fam.link.edit': 'تغيير ما يظهر',
  'fam.link.saved': 'تم الحفظ.',
  'fam.msg.view': 'مرحبًا! يمكنك متابعة طلباتي للدراسة في الخارج على PathsAbroad من هنا: {url}',
  'fam.msg.viewSubject': 'طلباتي للدراسة في الخارج',
  'fam.msg.pay': 'مرحبًا! هل يمكنك مساعدتي في دفع ثمن باقة {plan} في PathsAbroad؟ هذا رابط الدفع الآمن: {url}',
  'fam.msg.paySubject': 'دفع ثمن باقتي في PathsAbroad',
  'fam.pay.title': 'طلب الدفع من أحد الوالدين',
  'fam.pay.lead': 'إرسال رابط دفع إلى من يتكفّل بدراستك. يتم الدفع عبر Stripe، وتُضاف الباقة إلى حسابك. يعمل الرابط مرة واحدة، لمدة 14 يومًا.',
  'fam.pay.plan': 'الباقة',
  'fam.pay.create': 'إنشاء رابط دفع',
  'fam.pay.covered': 'باقاتك تغطي كل الخطط بالفعل.',
  'fam.pay.buyer': 'يحصل من يدفع على الإيصال. كل المبيعات نهائية ولا يُسترد ثمنها.',
  'fam.tooMany': 'لديك بالفعل 10 روابط نشطة من هذا النوع. يُرجى إيقاف أحدها أولًا.',
  'fam.view.title': 'التقدّم في الدراسة بالخارج',
  'fam.view.titleName': 'تقدّم {name} في الدراسة بالخارج',
  'fam.view.lead': 'هذه الصفحة مُشارَكة معك من {name}، وتُظهر المرحلة التي بلغها كل طلب جامعي. لا يمكن تغيير أي شيء هنا، ويمكن لـ {name} إيقاف المشاركة في أي وقت.',
  'fam.view.leadNoName': 'هذه الصفحة مُشارَكة معك من أحد الطلاب، وتُظهر المرحلة التي بلغها كل طلب جامعي. لا يمكن تغيير أي شيء هنا، ويمكن للطالب إيقاف المشاركة في أي وقت.',
  'fam.view.unis': 'الجامعات',
  'fam.view.unisEmpty': 'لا توجد جامعات في القائمة بعد.',
  'fam.view.deadlines': 'المواعيد القادمة',
  'fam.view.deadlinesEmpty': 'لا توجد مواعيد نهائية في الأشهر القليلة القادمة.',
  'fam.view.due': 'الموعد النهائي: {date}',
  'fam.view.decisionsHidden': 'لا تظهر قرارات القبول في هذه الصفحة.',
  'fam.view.passes': 'باقات PathsAbroad',
  'fam.view.passUntil': '{plan}: مفعّلة حتى {date}',
  'fam.view.noPass': 'لا توجد باقة مدفوعة حاليًا. إذا لزمت باقة، يمكن للطالب إرسال رابط دفع إليك.',
  'fam.view.updated': 'محدّثة حتى {date}.',
  'fam.view.about': 'يساعد PathsAbroad الطلاب على اختيار الجامعات في الخارج والتقديم إليها والحصول على التأشيرة والاستقرار.',
  'fam.view.invalid.title': 'هذا الرابط لم يعد يعمل',
  'fam.view.invalid.text': 'ربما أُوقفت المشاركة أو انتهت صلاحية الرابط. يُرجى طلب رابط جديد من الطالب.',
  'fam.wa.title': 'التذكيرات على واتساب',
  'fam.wa.lead': 'رسالة على واتساب من PathsAbroad عند اقتراب موعد مما يظهر في هذه الصفحة، وتقتصر على ما اختار {name} عرضه هنا.',
  'fam.wa.leadNoName': 'رسالة على واتساب من PathsAbroad عند اقتراب موعد مما يظهر في هذه الصفحة، وتقتصر على ما اختار الطالب عرضه هنا.',
  'fam.wa.phone': 'رقم واتساب',
  'fam.wa.phoneHint': 'مع رمز الدولة، مثل: ‎+234 803 123 4567',
  'fam.wa.consent': 'أوافق على أن يرسل لي PathsAbroad رسائل واتساب بخصوص طلبات {name}، ورمزًا لتأكيد رقمي. ويمكنني الإيقاف في أي وقت بالرد بكلمة STOP أو بزر «إيقاف التذكيرات».',
  'fam.wa.consentNoName': 'أوافق على أن يرسل لي PathsAbroad رسائل واتساب بخصوص طلبات الطالب، ورمزًا لتأكيد رقمي. ويمكنني الإيقاف في أي وقت بالرد بكلمة STOP أو بزر «إيقاف التذكيرات».',
  'fam.wa.consentNeeded': 'يُرجى تحديد المربع للموافقة على تذكيرات واتساب.',
  'fam.wa.send': 'إرسال الرمز',
  'fam.wa.sent': 'أرسلنا رمزًا من 6 أرقام إلى {phone} على واتساب. الرمز صالح لمدة 10 دقائق.',
  'fam.wa.code': 'الرمز من واتساب',
  'fam.wa.confirm': 'تأكيد',
  'fam.wa.resend': 'إرسال رمز جديد',
  'fam.wa.other': 'استخدام رقم آخر',
  'fam.wa.done': 'تم. ستصل التذكيرات إلى {phone} على واتساب. للإيقاف في أي وقت، يُرجى الرد بكلمة STOP.',
  'fam.wa.phoneInvalid': 'يُرجى إدخال رقم واتساب مع رمز الدولة، مثل: ‎+234 803 123 4567',
  'fam.wa.phoneNotMobile': 'يُرجى إدخال رقم جوال.',
  'fam.wa.phoneNotWhatsApp': 'لا يمكن لهذا الرقم استقبال رسائل واتساب. يُرجى التحقق منه.',
  'fam.wa.badCode': 'الرمز غير صحيح أو انتهت صلاحيته. يُرجى التحقق من رسالة واتساب أو طلب رمز جديد.',
  'fam.wa.privacy': 'يُحفظ الرقم مشفّرًا، ويُحذف عند الإيقاف أو عندما يوقف الطالب مشاركة هذه الصفحة.',
  'fam.status.applying': 'يجري إعداد الطلب',
  'fam.status.submitted': 'تم الإرسال',
  'fam.status.offer': 'عرض قبول',
  'fam.status.offer_conditional': 'عرض قبول مشروط',
  'fam.status.waitlisted': 'على قائمة الانتظار',
  'fam.status.deferred': 'تأجّل القرار',
  'fam.status.not_admitted': 'لم يُقبل الطلب',
  'fam.status.accepted': 'تم قبول العرض',
  'fam.status.declined': 'تم رفض العرض',
  'fam.status.withdrawn': 'تم سحب الطلب',
  'pay.title': 'دفع ثمن باقة في PathsAbroad',
  'pay.titleName': 'دفع ثمن باقة {plan} لحساب {name}',
  'pay.lead': 'وصلك هذا الرابط من {name} لدفع ثمن باقة {plan} في PathsAbroad. الباقة لحساب {name}، ولا حاجة إلى حساب خاص بك.',
  'pay.leadNoName': 'وصلك هذا الرابط من أحد الطلاب لدفع ثمن باقة {plan} في PathsAbroad. الباقة لحساب الطالب، ولا حاجة إلى حساب خاص بك.',
  'pay.price': 'السعر',
  'pay.oneTime': 'دفعة واحدة. لا يوجد تجديد تلقائي.',
  'pay.valid': 'صالحة لمدة {months} من يوم الدفع.',
  'pay.includes': 'ما تشمله',
  'pay.refund': 'كل المبيعات نهائية ولا يُسترد ثمنها. تنتقل الباقة إلى الموسم التالي إن لم يصل الطالب أي عرض قبول.',
  'pay.formTitle': 'الدفع',
  'pay.email': 'بريدك الإلكتروني',
  'pay.emailHint': 'لإرسال الإيصال.',
  'pay.country': 'بلد الإقامة',
  'pay.startNowTitle': 'قبل الدفع',
  'pay.startNow': 'ابدأ الباقة فور الدفع. أفهم أن كل المبيعات نهائية: بعد أن تبدأ، لا يمكن إلغاؤها أو استرداد ثمنها.',
  'pay.startNowNote': 'إن لم يصل الطالب أي عرض قبول، تنتقل الباقة إلى الموسم التالي مجانًا.',
  'pay.submit': 'دفع {price} عبر Stripe',
  'pay.secure': 'تتولى Stripe عملية الدفع، ولا يرى PathsAbroad رقم بطاقتك أبدًا.',
  'pay.canceled': 'أُلغيت عملية الدفع، ولم يُخصم أي مبلغ.',
  'pay.paid.title': 'تم دفع ثمن هذه الباقة',
  'pay.paid.text': 'شكرًا لك. الباقة مفعّلة في حساب الطالب، ووصلت إلى من دفع رسالة فيها الإيصال.',
  'pay.covered.title': 'لا يوجد ما يُدفع',
  'pay.covered.text': 'باقات الطالب تشمل هذه الخطة بالفعل.',
  'pay.invalid.title': 'رابط الدفع هذا لم يعد يعمل',
  'pay.invalid.text': 'ربما انتهت صلاحيته أو أُلغي. يُرجى طلب رابط جديد من الطالب.',
  'pay.done.title': 'شكرًا لك',
  'pay.done.waiting': 'جارٍ تأكيد الدفع…',
  'pay.done.ready': 'تم الدفع. باقة {plan} مفعّلة في حساب الطالب، وأرسلنا إليك رسالة تأكيد.',
  'pay.done.slow': 'تمت عملية الدفع، لكن تأكيدها يستغرق وقتًا أطول من المعتاد. سنرسل إليك رسالة عند اكتماله.',
  'pay.wd.title': 'عملية الشراء',
  'pay.wd.lead': 'دفعت ثمن باقة {plan} لحساب {name} في {date}.',
  'pay.wd.leadNoName': 'دفعت ثمن باقة {plan} في PathsAbroad في {date}.',
  'pay.wd.until': 'يمكن الانسحاب واسترداد المبلغ كاملًا حتى {date}.',
  'pay.wd.confirm1': 'يُعاد المبلغ كاملًا، {price}، إلى البطاقة التي دفعت بها.',
  'pay.wd.confirm2': 'تنتهي الباقة فورًا في حساب الطالب.',
  'pay.wd.confirm3': 'سنرسل إليك إيصالًا مؤرّخًا بالبريد الإلكتروني.',
  'pay.wd.keep': 'الإبقاء على الباقة',
  'pay.wd.done': 'أُعيد المبلغ في {date}، وهو في طريقه إلى البطاقة التي دفعت بها.',
  'pay.wd.over': 'كل المبيعات نهائية: لا يمكن الانسحاب من هذا الشراء أو استرداد ثمنه.',
  'pay.wd.invalid': 'رابط الانسحاب هذا غير صالح.',
  'plans.askParent': 'طلب الدفع من أحد الوالدين',
  'plans.askParentMinor': 'هل عمرك أقل من 18 عامًا؟ يمكن لأحد والديك أو ولي أمرك دفع ثمن باقتك عبر رابط دفع آمن.',
  'pass.byParent': 'دُفع عبر رابط الدفع الخاص بك',

  /* the landing page ("/") */
  'land.nav.label': 'في هذه الصفحة',
  'land.nav.money': 'المنح',
  'land.nav.how': 'كيف يعمل',
  'land.nav.features': 'المزايا',
  'land.nav.trust': 'الخصوصية',
  'land.nav.pricing': 'إنه مجاني',
  'land.nav.faq': 'أسئلة شائعة',
  'land.nav.demo': 'تجربة',
  'land.getStarted': 'ابدأ الآن',
  'land.globe.title': 'إلى أين تريد أن تذهب؟',
  'land.globe.lead': 'اضغط على أي مكان في الكرة الأرضية، وسنقرّبك من أقرب جامعة ونُريك كيف هي.',
  'land.globe.search': 'ابحث عن مدينة أو دولة أو جامعة',
  'land.globe.none': 'لا نتائج. جرّب مدينة أو دولة أو جامعة.',
  'land.globe.aria': 'كرة أرضية تدور ببطء وعليها {unis} جامعة. اسحبها لتديرها، ومرّر للأعلى أو باعِد بإصبعين للتكبير، واضغط على أي مكان لترى أقرب جامعة. بلوحة المفاتيح: الأسهم تديرها، و+ و− للتكبير والتصغير، وزر Enter يُظهر الجامعة الأقرب إلى المنتصف.',
  'land.globe.closest': 'أقرب جامعة',
  'land.globe.yourPick': 'اختيارك',
  'land.globe.away': 'على بُعد {d} من حيث ضغطت',
  'land.globe.here': 'حيث ضغطت تمامًا',
  'land.globe.km': '{n} كم',
  'land.globe.close': 'إغلاق',
  'land.globe.rank': 'الترتيب العالمي',
  'land.globe.notRanked': 'غير مصنّفة',
  'land.globe.inCountry': 'في {country}',
  'land.globe.rankOf': '{r} من {n}',
  'land.globe.cost': 'في السنة',
  'land.globe.costOwn': 'رسومها الدراسية ({year}) مع المعيشة',
  'land.globe.costOwn0': 'رسومها الدراسية مع المعيشة',
  'land.globe.costEst': 'تقدير: الرسوم الدراسية مع المعيشة',
  'land.globe.admit': 'نسبة القبول',
  'land.globe.admitYear': 'عام {year}',
  'land.globe.select': 'مدى صعوبة القبول',
  'land.globe.sel.high': 'صعب جدًا',
  'land.globe.sel.mid': 'صعب',
  'land.globe.sel.some': 'متوسط',
  'land.globe.sel.low': 'أسهل في القبول',
  'land.globe.sel.open': 'قبول مفتوح',
  'land.globe.selRank': 'بحسب ترتيبها العالمي',
  'land.globe.public': 'حكومية',
  'land.globe.private': 'خاصة',
  'land.globe.cc': 'كلية مجتمع',
  'land.globe.taught': 'لغة الدراسة في {country}: {langs}',
  'land.globe.students': '{n} طالب',
  'land.globe.founded': 'تأسست عام {year}',
  'land.globe.begin': 'لنبدأ',
  'land.globe.demo': 'جرّب النسخة التجريبية',
  'land.globe.again': 'اختر مكانًا آخر',
  'land.hero.note': 'مجاني لكل طالب. لا إعلانات ولا تتبّع.',
  'land.hero.signin': 'لديك حساب بالفعل؟ {link}',
  'land.facts.label': 'PathsAbroad باختصار',
  'land.facts.unis': '{unis} جامعة في {countries} دولة',
  'land.facts.langs': 'بالعربية والإنجليزية والهندية والإندونيسية',
  'land.facts.portals': 'يعبّئ نماذج Common App و UCAS و OUAC و uni-assist',
  'land.facts.ads': 'بلا إعلانات، ولا تُباع بياناتك أبدًا',
  'land.how.title': 'من لمسة على الكرة الأرضية إلى أول أسبوع لك في الخارج.',
  'land.how.lead': 'سبع خطوات في تطبيق واحد. في كل خطوة: ما تفعله أنت، وما يفعله PathsAbroad من أجلك.',
  'land.how.step': 'الخطوة {n} من {total}',
  'land.how.you': 'أنت',
  'land.how.s1.title': 'اختر الأماكن التي تحلم بالدراسة فيها',
  'land.how.s1.time': 'دقيقة تقريبًا',
  'land.how.s1.text': 'تبدأ الرحلة على كرة أرضية. اضغط على النقاط المضيئة، أو ابحث عن مدينة أو دولة أو جامعة: {unis} جامعة في {countries} دولة، كلٌّ منها في مكانها الحقيقي.',
  'land.how.s1.you': 'اضغط على كل مكان يلفت نظرك.',
  'land.how.s1.pa': 'يجد الجامعات الأقرب إلى كل مكان، الأقرب أولًا، مع المسافة.',
  'land.how.s2.title': 'أجب عن خمسة أسئلة سريعة',
  'land.how.s2.time': 'دقيقتان تقريبًا',
  'land.how.s2.text': 'محادثة قصيرة عنك وعن بلدك، والعمل الذي تريده، ودرجاتك، ولغتك الإنجليزية، وميزانيتك. قل «مهندس مدني» ويحدد المرشد الشهادة التي توصلك إلى ذلك.',
  'land.how.s2.you': 'أجب بكلماتك، أو اضغط على أحد الاقتراحات.',
  'land.how.s2.pa': 'يحوّل إجاباتك إلى ملف شخصي يقارنه بكل جامعة.',
  'land.how.s3.title': 'تعرّف على الجامعات المناسبة لك',
  'land.how.s3.time': 'فورًا',
  'land.how.s3.text': 'تضيء الجامعات المناسبة لك على الكرة الأرضية، مرتبةً حسب درجاتك وميزانيتك وأهدافك. تُظهر كل واحدة سبب مناسبتها لك، وتكلفة السنة، وفرصتك في القبول، مع المنح الدراسية التي تناسبك.',
  'land.how.s3.you': 'احتفظ بما يعجبك، أو أضف أي جامعة تريدها. يحفظ حساب مجاني قائمتك.',
  'land.how.s3.pa': 'يصارحك بفرصك: مرجّحة أو مناسبة أو طموحة.',
  'land.how.s4.title': 'اتبع خطتك خطوة بخطوة',
  'land.how.s4.time': 'أثناء تقدّمك',
  'land.how.s4.text': 'تعرض الصفحة الرئيسية دائمًا خطوتك التالية وما هو قادم: المستندات وخطابات التوصية والمقالات والرسوم لكل جامعة، حسب التاريخ. ويرشدك المرشد الذكي في كل خطوة. تبدأ مقالاتك من ملاحظاتك أنت، وتحصل على ملاحظات عليها، لا على مقال معاد كتابته.',
  'land.how.s4.you': 'أنجز الخطوة التالية متى كنت مستعدًا.',
  'land.how.s4.pa': 'يرتّب كل المواعيد، ويذكّرك عبر واتساب أو البريد الإلكتروني إن أردت.',
  'land.how.s5.title': 'املأ النماذج في ثوانٍ، ثم قدّمها بنفسك',
  'land.how.s5.time': 'ثوانٍ لكل صفحة',
  'land.how.s5.text': 'في Common App و UCAS و OUAC و uni-assist، اضغط «املأ هذه الصفحة» فتضع إضافة كروم من PathsAbroad الإجابات التي قدّمتها من قبل. أنت من يراجع كل حقل، ويكتب مقالاته بنفسه، ويضغط زر الإرسال.',
  'land.how.s5.you': 'راجع كل حقل، ثم قدّم وادفع على موقع الجامعة نفسه.',
  'land.how.s5.pa': 'يملأ ما أخبرته به. لا يكتب مقالاتك ولا كلمات مرورك، ولا يضغط أبدًا زر الإرسال أو الدفع.',
  'land.how.s6.title': 'تصلك الردود في مكان واحد',
  'land.how.s6.time': 'كلما وصلت أخبار',
  'land.how.s6.text': 'تراسلك الجامعات على عنوانك الخاص من PathsAbroad. تُرتَّب القرارات ودعوات المقابلات وطلبات المستندات فور وصولها، وتُضاف الخطوة التالية إلى قائمتك. ويمكن لعائلتك متابعة تقدّمك عبر صفحة للقراءة فقط.',
  'land.how.s6.you': 'اقرأ الأخبار وردّ على عروض القبول.',
  'land.how.s6.pa': 'يرتّب كل رسالة، ويستخرج المواعيد والخطوات التالية.',
  'land.how.s7.title': 'استعدّ للسفر',
  'land.how.s7.time': 'بعد حصولك على عرض قبول',
  'land.how.s7.text': 'قائمة متطلبات التأشيرة لوجهتك مع روابط لمصادر رسمية، إضافةً إلى التمويل من بلدك ومن الخارج، والسكن والطعام ووظائف الطلاب وأسابيعك الأولى. معلومات عامة، وليست استشارة هجرة أو استشارة قانونية.',
  'land.how.s7.you': 'اقبل عرضك وأنجز قائمتك.',
  'land.how.s7.pa': 'يعرض خطوات وجهتك، وينبّهك حين تؤثر قاعدة تأشيرة على جنسيتك.',
  'land.money.eyebrow': 'المنح',
  'land.money.title': 'نجد لك التمويل. نراجع لك كل منحة.',
  'land.money.lead': 'منح الطلاب الدوليين موزّعة على مئات المواقع الحكومية ومواقع المؤسسات. يراجع PathsAbroad {n} منحة منها في {countries} دولة بحسب جنسيتك ومستواك الدراسي ووجهتك، ويعرض قيمة كل واحدة.',
  'land.money.s1': 'منحة ومساعدة نراجعها لكل طالب',
  'land.money.s2': 'في السنة: أعلى قيمة لمنحة واحدة',
  'land.money.s3': 'دولة، مع منح حكوماتها والجهات الدولية الكبرى',
  'land.money.ex_eyebrow': 'مثال',
  'land.money.ex_who': 'أمينة من الأردن تريد الماجستير في كندا أو بريطانيا أو ألمانيا',
  'land.money.ex_v': '{n} منحة يمكنها التقديم عليها، قيمتها حتى {amt} في السنة',
  'land.money.peryear': '{amt} في السنة',
  'land.money.eu': 'أوروبا',
  'land.money.intl': 'دولية',
  'land.money.cta': 'اعرض المنح التي يمكنك الحصول عليها',
  'land.money.fine': 'القيم سنوية ومأخوذة من صفحات كل برنامج. حين يغطي البرنامج «الرسوم كاملة» نقدّرها برسوم معتادة ونذكر أنها تقديرية. لا يمكن عادةً الجمع بين المنح. راجعناها في أكتوبر 2026.',
  'land.how.d.where': 'أين ترى نفسك تدرس؟',
  'land.how.d.continue': 'متابعة ({n})',
  'land.how.d.guide': 'المرشد الذكي',
  'land.how.d.career': 'ما المهنة التي تريد العمل بها؟ سأحدد الشهادة المناسبة بناءً على ذلك.',
  'land.how.d.civil': 'مهندس مدني',
  'land.how.d.level': 'لتصبح مهندسًا مدنيًا، الخطوة المعتادة بعد البكالوريوس هي الماجستير. هل أعتمد ذلك؟',
  'land.how.d.yes': 'نعم',
  'land.how.d.finding': 'أبحث عن الجامعات المناسبة لك…',
  'land.how.d.scholar': '3 منح دراسية تناسبك',
  'land.how.d.save': 'احفظ قائمتي',
  'land.how.d.next': 'التالي: احصل على 3 توصيات. اضغط وسأرشدك خطوة بخطوة.',
  'land.how.d.ask': 'اسأل',
  'land.how.d.task': 'احصل على 3 توصيات',
  'land.how.d.due': 'خلال يومين',
  'land.how.d.doIt': 'أنجزها الآن',
  'land.how.d.coming': 'قادم قريبًا',
  'land.how.d.deadline': 'آخر موعد للتقديم: {school}',
  'land.how.d.inDays': 'بعد {n} يومًا',
  'land.how.d.trip': 'رحلتك',
  'land.how.d.starts': 'تبدأ الدراسة في سبتمبر',
  'land.how.d.visa': 'قائمة متطلبات التأشيرة',
  'land.features.title': 'كل ما تحتاجه للدراسة في الخارج، في مكان واحد.',
  'land.features.lead': 'هكذا يبدو مع مثال لطالبة: أمينة من الأردن.',
  'land.match.eyebrow': 'جامعات تناسبك',
  'land.match.title': 'جامعات تناسبك، وفرص قبول بصراحة.',
  'land.match.text': 'أخبر PathsAbroad بدرجاتك وميزانيتك وأهدافك، فيقترح عليك جامعات تناسبك، مع التكلفة السنوية وفرصتك في كل منها: مرجّحة أو مناسبة أو طموحة.',
  'land.match.p1': 'اعرف لماذا تناسبك كل جامعة، وكم تكلّف.',
  'land.match.p2': 'أفضل المنح لك، مطابقةً لملفك.',
  'land.match.p3': 'أضف أي جامعة، حتى التي لم نقترحها.',
  'land.apply.eyebrow': 'التقديم',
  'land.apply.title': 'املأ نماذج التقديم في ثوانٍ، وأرسلها بنفسك.',
  'land.apply.text': 'تضع إضافة كروم من PathsAbroad إجاباتك المحفوظة في Common App و UCAS و OUAC و uni-assist عندما تضغط «املأ هذه الصفحة»، وأنت من يراجع كل حقل.',
  'land.apply.p3': 'لا تعمل إلا عندما تضغط الزر، ولا تعمل في مواقع التأشيرات والمواقع الحكومية.',
  'land.inbox.eyebrow': 'بريد الطلبات',
  'land.inbox.title': 'كل رسائل القبول، مرتّبة لك.',
  'land.inbox.text': 'استخدم عنوان بريدك الخاص من PathsAbroad في بوابات التقديم. تُرتَّب القرارات ودعوات المقابلات وطلبات المستندات، وتُضاف الخطوة التالية إلى قائمة مهامك.',
  'land.inbox.p1': 'المواعيد والخطوات التالية مستخرجة من كل رسالة.',
  'land.inbox.p2': 'تذكيرات قبل كل موعد نهائي، إن أردتها.',
  'land.inbox.p3': 'تُحفظ الرسائل الكاملة مشفّرة لمدة 30 يومًا، ثم تُحذف.',
  'land.ai.title': 'مرشد بالذكاء الاصطناعي يشرح لك، ولا يكتب عنك أبدًا.',
  'land.ai.text': 'اسأل عن التخصصات أو التكاليف أو التأشيرات واحصل على إجابات واضحة، عليها دائمًا علامة الذكاء الاصطناعي. يبدأ كل مقال برؤوس أقلام من إجاباتك أنت؛ تكتبه بنفسك، ثم تحصل على ملاحظات، لا على مقال أُعيدت كتابته. الذكاء الاصطناعي مجاني لكل طالب.',
  'land.reminders.title': 'تذكيرات عبر واتساب أو البريد الإلكتروني.',
  'land.reminders.text': 'تصلك رسالة قبل الموعد النهائي بسبعة أيام وثلاثة أيام ويوم واحد، وفي يومه أيضًا. وللإيقاف ردّ بكلمة STOP.',
  'land.visa.title': 'خطوات التأشيرة وأسابيعك الأولى.',
  'land.visa.text': 'قائمة متطلبات لكل وجهة مع روابط لمصادر رسمية، ثم السكن والطعام ووظائف الطلاب. معلومات عامة، وليست استشارة هجرة أو استشارة قانونية.',
  'land.family.title': 'أشرك عائلتك.',
  'land.family.text': 'شارك صفحة تقدّم للقراءة فقط مع أحد والديك أو أي شخص تختاره. ويمكنك إيقاف المشاركة في أي وقت.',
  'land.lang.title': 'بلغتك.',
  'land.lang.text': 'استخدم PathsAbroad بالعربية أو الإنجليزية أو الهندية أو الإندونيسية، وبدّل اللغة في أي وقت.',
  'land.trust.title': 'مصمَّم لحماية الطلاب.',
  'land.trust.lead': 'أرقام جوازات السفر والدرجات وتفاصيل العائلة من أكثر ما تشاركه خصوصية. إليك كيف يحميها PathsAbroad.',
  'land.trust.enc.title': 'مشفّرة قبل حفظها',
  'land.trust.enc.text': 'يُشفَّر رقم جواز سفرك وتاريخ ميلادك ودخل عائلتك وكل ما تحفظه في المخطِّط ورسائل القبول باستخدام AES-256-GCM، ولا تخزّن قاعدة البيانات إلا النسخة المشفّرة.',
  'land.trust.rls.title': 'سجلاتك لك وحدك',
  'land.trust.rls.text': 'كل صف في قاعدة البيانات مقفل على صاحبه بحماية على مستوى الصفوف، فلا يستطيع أي طالب قراءة بيانات طالب آخر.',
  'land.trust.redact.title': 'بياناتك الخاصة لا تصل إلى الذكاء الاصطناعي',
  'land.trust.redact.text': 'تُحذف أرقام جوازات السفر وتواريخ الميلاد وأرقام الهواتف وعناوين البريد الإلكتروني والعناوين قبل إرسال أي شيء إلى الذكاء الاصطناعي، ولا يُرسَل العرق أو الدين أو دخل العائلة أبدًا.',
  'land.trust.ai.title': 'نصوص الذكاء الاصطناعي معلَّمة دائمًا',
  'land.trust.ai.text': 'كل ما يكتبه الذكاء الاصطناعي عليه علامة تبيّن ذلك، ويمكن لأي شخص التحقق مما إذا كان نصّ ما صادرًا عن PathsAbroad.',
  'land.trust.aiCheck': 'تحقّق من نص',
  'land.trust.mfa.text': 'أضف رمزًا من تطبيق مصادقة، حتى لا تكفي كلمة مرور مسروقة للدخول إلى حسابك.',
  'land.trust.help.title': 'المساعدة حين تلزم',
  'land.trust.help.text': 'إذا أوحت رسالة بأن أحدًا قد يكون في خطر، يردّ المرشد بأرقام خطوط المساعدة في بلده.',
  'land.trust.data.title': 'بياناتك، وقرارك',
  'land.trust.data.text': 'نزّل كل بياناتك، أو احذف حسابك، في أي وقت. لا يُباع شيء ولا يُستخدم للإعلانات.',
  'land.price.title': 'مجاني لكل طالب.',
  'land.price.lead': 'لا باقات ولا اشتراك ولا بطاقة. كل ما في PathsAbroad مجاني للطلاب الذاهبين للدراسة في بلد آخر.',
  'land.price.from': 'من أين أنت؟',
  'land.price.to': 'أين تريد الدراسة؟',
  'land.price.chooseFrom': 'اختر بلدك',
  'land.price.chooseTo': 'اختر بلدًا',
  'land.price.notSure': 'لم أقرر بعد',
  'land.price.pick': 'أجب عن السؤالين لتعرف سعرك.',
  'land.price.yours': 'سعرك للدراسة في {country}',
  'land.price.yoursAny': 'سعرك',
  'land.price.freeNote': 'كل شيء، بلا حد زمني',
  'land.price.how': 'كيف نحصل على المال: تدفع بعض الجامعات وخدمات الطلاب (القروض والسكن والحسابات المجمّدة) رسومًا لـ PathsAbroad عندما يلتحق طالب أو يسجّل عن طريقنا. لا يكلّفك ذلك أي شيء إضافي، ولا يغيّر أبدًا الجامعات المقترحة لك: فهي مرتّبة فقط بحسب مدى مناسبة كل جامعة لك.',
  'land.price.abroad': 'PathsAbroad للدراسة خارج بلدك، لذلك لا نعرض جامعات البلد الذي أنت منه.',
  'land.price.for': 'دفعة واحدة، صالحة لمدة {months}',
  'land.price.usd': 'الأسعار بالدولار الأمريكي، وترى سعرك دائمًا قبل الدفع.',
  'land.price.parents': 'يمكن لأحد والديك الدفع عنك عبر رابط آمن.',
  'land.cta.free': 'ابدأ مجانًا',
  'land.cta.planner': 'جرّب المخطِّط',
  'land.faq.title': 'أسئلة وأجوبة.',
  'land.faq.q1': 'هل PathsAbroad مجاني؟',
  'land.faq.a1': 'نعم، بالكامل: البحث عن الجامعات، وفرصك، والمرشد الذكي، والطيار الآلي، والمساعدة في المقالات، وطلبات كل المنح، وإضافة كروم، وبريد الطلبات، ومساعدة التأشيرة والوصول. تدفع لنا الجامعات وخدمات الطلاب، ولا يدفع الطلاب أبدًا.',
  'land.faq.q2': 'هل يقدّم PathsAbroad الطلبات بدلًا مني؟',
  'land.faq.a2': 'لا. أنت من يختار جامعاته، ويكتب مقالاته، ويرسل كل طلب ويدفع رسومه بنفسه. يعبّئ PathsAbroad بياناتك المحفوظة، ويبدأ كل مقال برؤوس أقلام من إجاباتك، ويساعدك على تنظيم أمورك.',
  'land.faq.q3': 'هل هذه استشارة هجرة أو استشارة قانونية؟',
  'land.faq.a3': 'لا. ترتبط معلومات التأشيرة بمصادر رسمية، وهي معلومات عامة وليست استشارة هجرة أو استشارة قانونية. تحقّق دائمًا من الموقع الرسمي فيما يخص حالتك.',
  'land.faq.q4': 'ما الجامعات التي يمكنني إيجادها؟',
  'land.faq.a4': '{unis} جامعة في {countries} دولة، منها الولايات المتحدة والمملكة المتحدة وكندا وأستراليا وألمانيا. PathsAbroad للدراسة في الخارج، لذلك لا تظهر جامعات بلدك. ويمكنك أيضًا إضافة أي جامعة بنفسك.',
  'land.faq.q5': 'ماذا لو كان عمري أقل من 18 عامًا؟',
  'land.faq.a5': 'يوافق أحد والديك أو ولي أمرك على حسابك قبل أن تتمكن من حفظ بياناتك، وتبقى بعض أسئلة الملف الحساسة غير متاحة.',
  'land.faq.q6': 'كيف يكسب PathsAbroad المال؟',
  'land.faq.a6': 'تدفع لنا بعض الجامعات وخدمات الطلاب رسومًا عندما يلتحق طالب أو يسجّل عن طريق PathsAbroad. أنت لا تدفع لنا شيئًا أبدًا، ولا تغيّر هذه الرسوم الجامعات التي نقترحها لك.',
  'land.faq.q7': 'هل يمكن لوالديّ متابعة تقدّمي؟',
  'land.faq.a7': 'فقط إذا اخترت ذلك. يمكنك مشاركة صفحة للقراءة فقط مع أحد والديك أو ولي أمرك، وإيقاف المشاركة في أي وقت.',
  'land.faq.q8': 'ماذا يحدث لبياناتي؟',
  'land.faq.a8': 'الإجابات الحساسة مشفّرة، ولا يُباع شيء ولا يُستخدم للإعلانات. ويمكنك تنزيل كل شيء أو حذفه من حسابك.',
  'land.final.title': 'ابدأ طريقك اليوم.',
  'land.final.text': 'أنشئ حسابًا مجانيًا، أو جرّب المخطِّط أولًا.',
  'land.demo.example': 'مثال',
  'land.demo.matches': 'الجامعات المقترحة لك',
  'land.demo.inbox': 'بريد الطلبات',
  'land.demo.decision': 'قرار',
  'land.demo.nextReply': 'أُضيفت الخطوة التالية إلى قائمتك',
  'land.demo.whatsapp': 'واتساب',
  'land.demo.reminder': 'بقيت 3 أيام للرد على عرض القبول من {school}.',
  'land.demo.all': 'الكل',
  'land.demo.likely': 'مرجّحة',
  'land.demo.fit': 'مناسبة',
  'land.demo.ambitious': 'طموحة',
  'land.demo.estimate': 'الفرص تقديرات، وليست وعودًا.',
  'land.demo.firstName': 'الاسم الأول',
  'land.demo.lastName': 'اسم العائلة',
  'land.demo.citizenship': 'الجنسية',
  'land.demo.essay': 'المقال الشخصي',
  'land.demo.youWrite': 'تكتبه أنت',
  'land.demo.submit': 'إرسال',
  'land.demo.youSubmit': 'أنت من يضغط «إرسال»',
  'land.demo.fill': 'املأ هذه الصفحة',
  'land.demo.filled': 'تم ملء 3 حقول',
  'land.demo.offer': 'حصلت على عرض قبول.',
  'land.demo.interview': 'مقابلة',
  'land.demo.interviewText': 'اختر موعدًا لمقابلتك.',
  'land.demo.missing': 'مستند ناقص',
  'land.demo.missingText': 'ارفع نتائج اختبار اللغة الإنجليزية.',
  'land.demo.todo': 'أُضيف إلى قائمة مهامك:',
  'land.demo.aiQ': 'ماذا يعني عرض القبول المشروط؟',
  'land.demo.aiA': 'يعني أن الجامعة ستقبلك بعد أن تستوفي الشروط المذكورة في رسالتك، وغالبًا ما تكون درجاتك النهائية أو نتيجة اختبار في اللغة الإنجليزية.',
  'land.demo.visa1': 'رسالة القبول',
  'land.demo.visa2': 'إثبات القدرة المالية',
  'land.demo.visa3': 'التأمين الصحي',
  'land.demo.visa4': 'حجز موعد التأشيرة',
  'land.demo.parentView': 'ما يراه والداك',
  'land.demo.youSee': 'ما تراه أنت',
  'land.demo.stored': 'ما تخزّنه قاعدة البيانات',
};
